import { createContext } from 'react';
import RootStore from '../state/stores';

const StoresContext = createContext(new RootStore());
export default StoresContext;
